import { lazy } from 'react'

const Home = lazy(() => import('features/dashboard/pages/HomePage'))

const AllVehicle = lazy(
  () => import('features/vehicles/pages/All/AllVehiclesPage'),
)
const DraftVehicle = lazy(
  () => import('features/vehicles/pages/Draft/DraftVehiclesPage'),
)
const LiveVehicle = lazy(
  () => import('features/vehicles/pages/Live/LiveVehiclesPage'),
)
const BuyItNowVehicle = lazy(
  () => import('features/vehicles/pages/BuyItNow/BuyItNowVehiclesPage'),
)
const ScheduledVehicle = lazy(
  () => import('features/vehicles/pages/Scheduled/ScheduledVehiclesPage'),
)
const PendingVehicle = lazy(
  () => import('features/vehicles/pages/Pending/PendingVehiclesPage'),
)
const ClosedVehicle = lazy(
  () => import('features/vehicles/pages/Closed/ClosedVehiclesPage'),
)
const SoldVehicle = lazy(
  () => import('features/vehicles/pages/Sold/SoldVehiclesPage'),
)
const ParkingVehicle = lazy(
  () => import('features/vehicles/pages/Parking/ParkingVehiclesPage'),
)

const VinDecoder = lazy(() => import('features/vehicles/pages/VinDecoderPage'))

const ViewVehicle = lazy(
  () => import('features/vehicles/pages/VehicleViewPage'),
)
const AddVehicle = lazy(() => import('features/vehicles/pages/VehicleAddPage'))
const EditVehicle = lazy(
  () => import('features/vehicles/pages/VehicleEditPage'),
)
const BuyItNowVehicleView = lazy(
  () => import('features/vehicles/pages/BuyItNow/BuyItNowViewPage'),
)

const AllUser = lazy(() => import('features/users/pages/All/AllUsersPage'))
const PendingUser = lazy(
  () => import('features/users/pages/Pending/PendingUsersPage'),
)
const SellerUser = lazy(
  () => import('features/users/pages/Sellers/SellersPage'),
)
const BuyerUser = lazy(() => import('features/users/pages/Buyers/BuyersPage'))
const RoleChangeRequests = lazy(
  () =>
    import('features/users/pages/RoleSwitchRequests/RoleSwitchRequestsPage'),
)
const ShareInventoryRequests = lazy(
  () =>
    import('features/users/pages/ShareInventoryRequests/ShareInventoryRequestsPage'),
)

const View = lazy(() => import('features/users/pages/UserViewPage'))
const AddUser = lazy(() => import('features/users/pages/UserAddPage'))
const EditUser = lazy(() => import('features/users/pages/UserEditPage'))

const TimeFrame = lazy(() => import('features/settings/pages/TimeFramePage'))

const AllAnnouncement = lazy(
  () => import('features/announcements/pages/AnnouncementListPage'),
)
const EditAnnouncement = lazy(
  () => import('features/announcements/pages/AnnouncementEditPage'),
)
const ViewAnnouncement = lazy(
  () => import('features/announcements/pages/AnnouncementViewPage'),
)
const AddAnnouncement = lazy(
  () => import('features/announcements/pages/AnnouncementAddPage'),
)

const AllTax = lazy(() => import('features/settings/pages/tax/TaxListPage'))
const AddTax = lazy(() => import('features/settings/pages/tax/TaxAddPage'))
const EditTax = lazy(() => import('features/settings/pages/tax/TaxEditPage'))
const ViewTax = lazy(() => import('features/settings/pages/tax/TaxViewPage'))

const AdminProfile = lazy(() => import('features/auth/pages/ProfilePage'))

const Notifications = lazy(
  () => import('features/notifications/pages/NotificationListPage'),
)

const AllTemplate = lazy(
  () => import('features/settings/pages/templates/TemplateListPage'),
)
const AddTemplate = lazy(
  () => import('features/settings/pages/templates/TemplateAddPage'),
)
const EditTemplate = lazy(
  () => import('features/settings/pages/templates/TemplateEditPage'),
)
const ViewTemplate = lazy(
  () => import('features/settings/pages/templates/TemplateViewPage'),
)
const DefaultBuyerFee = lazy(
  () => import('features/settings/pages/DefaultBuyerFeePage'),
)
const SendNotifications = lazy(
  () => import('features/notifications/pages/SendNotificationPage'),
)
const AdminMaintenance = lazy(
  () => import('features/settings/pages/MaintenancePage'),
)
const SalesReports = lazy(
  () => import('features/reports/pages/SalesReportsPage'),
)
const AdminVersion = lazy(
  () => import('features/settings/pages/AppVersionPage'),
)
const AllTerms = lazy(
  () => import('features/settings/pages/terms/TermsListPage'),
)
const AddTerms = lazy(
  () => import('features/settings/pages/terms/TermsAddPage'),
)
const EditTerms = lazy(
  () => import('features/settings/pages/terms/TermsEditPage'),
)
const AllOptions = lazy(
  () => import('features/settings/pages/options/OptionsListPage'),
)
const AddOption = lazy(
  () => import('features/settings/pages/options/OptionAddPage'),
)
const EditOption = lazy(
  () => import('features/settings/pages/options/OptionEditPage'),
)
const ViewOption = lazy(
  () => import('features/settings/pages/options/OptionViewPage'),
)
const FeatureFlags = lazy(
  () => import('features/settings/pages/FeatureFlagsPage'),
)

const AllRoutes = [
  { path: '/', element: <Home /> },
  { path: '/vehicle/all', element: <AllVehicle /> },
  { path: '/vehicle/parking', element: <ParkingVehicle /> },
  { path: '/vehicle/draft', element: <DraftVehicle /> },
  { path: '/vehicle/live', element: <LiveVehicle /> },
  { path: '/vehicle/buy-it-now', element: <BuyItNowVehicle /> },
  { path: '/vehicle/schedule', element: <ScheduledVehicle /> },
  { path: '/vehicle/pending', element: <PendingVehicle /> },
  { path: '/vehicle/closed', element: <ClosedVehicle /> },
  { path: '/vehicle/sold', element: <SoldVehicle /> },

  { path: '/vin/decoder', element: <VinDecoder /> },
  { path: '/vehicle/add', element: <AddVehicle /> },
  { path: '/vehicle/edit/:userId/:id', element: <EditVehicle /> },
  { path: '/vehicle/view/:id', element: <ViewVehicle /> },
  { path: '/vehicle/buy-it-now/view/:id', element: <BuyItNowVehicleView /> },

  { path: '/user/all', element: <AllUser /> },
  { path: '/user/pending', element: <PendingUser /> },
  { path: '/user/seller', element: <SellerUser /> },
  { path: '/user/buyer', element: <BuyerUser /> },
  { path: '/user/role-change-requests', element: <RoleChangeRequests /> },
  {
    path: '/user/share-inventory-requests',
    element: <ShareInventoryRequests />,
  },

  { path: '/user/add', element: <AddUser /> },
  { path: '/user/edit/:id', element: <EditUser /> },
  { path: '/user/view/:id', element: <View /> },

  { path: '/setting/offer-time', element: <TimeFrame /> },
  { path: '/setting/default-buyer-fee', element: <DefaultBuyerFee /> },

  { path: '/announcement/all', element: <AllAnnouncement /> },
  { path: '/send-notification', element: <SendNotifications /> },
  { path: '/announcement/edit/:id', element: <EditAnnouncement /> },
  { path: '/announcement/view/:id', element: <ViewAnnouncement /> },
  { path: '/announcement/create', element: <AddAnnouncement /> },

  { path: '/setting/tax/all', element: <AllTax /> },
  { path: '/setting/tax/edit/:id', element: <EditTax /> },
  { path: '/setting/tax/view/:id', element: <ViewTax /> },
  { path: '/setting/tax/create', element: <AddTax /> },

  { path: '/admin/profile', element: <AdminProfile /> },
  { path: '/notifications', element: <Notifications /> },

  { path: '/setting/template/all', element: <AllTemplate /> },
  { path: '/setting/template/edit/:id', element: <EditTemplate /> },
  { path: '/setting/template/view/:id', element: <ViewTemplate /> },
  { path: '/setting/template/create', element: <AddTemplate /> },

  { path: '/setting/terms/all', element: <AllTerms /> },
  { path: '/setting/terms/edit/:id', element: <EditTerms /> },
  { path: '/setting/terms/create', element: <AddTerms /> },

  { path: '/setting/options/all', element: <AllOptions /> },
  { path: '/setting/options/create', element: <AddOption /> },
  { path: '/setting/options/edit/:id', element: <EditOption /> },
  { path: '/setting/options/view/:id', element: <ViewOption /> },

  { path: '/reports', element: <SalesReports /> },
  { path: '/maintenance', element: <AdminMaintenance /> },
  { path: '/app-version', element: <AdminVersion /> },
  { path: '/feature-flags', element: <FeatureFlags /> },
]

export default AllRoutes
